import { FC } from 'react';
import { PageTitle } from '../../../../rbts/layout/core';
import { View } from './components/View';

const TurnosPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Turnos</PageTitle>
      <View />
    </>
  );
};

export { TurnosPage };
